import { render, staticRenderFns } from "./discountSetting.vue?vue&type=template&id=0685afeb&"
import script from "./discountSetting.vue?vue&type=script&lang=ts&"
export * from "./discountSetting.vue?vue&type=script&lang=ts&"
import style0 from "./discountSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports